import { render } from "./ReceiptModal.vue?vue&type=template&id=62287330"
import script from "./ReceiptModal.vue?vue&type=script&lang=js"
export * from "./ReceiptModal.vue?vue&type=script&lang=js"

import "./ReceiptModal.vue?vue&type=style&index=0&id=62287330&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__